// extracted by mini-css-extract-plugin
module.exports = {"footer":"src-hellospa-components-tour-styles__footer--14W51"};